export type OnboardingFlowStage = "intro" | "form" | "verticals" | "success";

export const VALID_ONBOARDING_FLOW_STAGES = [
  "intro",
  "form",
  "verticals",
  "success",
] satisfies OnboardingFlowStage[];

// v1 had `projectTypes` and `specifyMatrix` stages. Their work moved into the
// trades step, so an old link or bookmark opens that one.
const LEGACY_STAGES = {
  projectTypes: "verticals",
  specifyMatrix: "verticals",
} as const satisfies Record<string, OnboardingFlowStage>;

const isLegacyStage = (value: string): value is keyof typeof LEGACY_STAGES =>
  Object.hasOwn(LEGACY_STAGES, value);

/** Reads the `ofs` URL parameter: a stage, a v1 stage mapped to its successor, or `null`. */
export function parseOnboardingFlowStage(
  value: string | null
): OnboardingFlowStage | null {
  if (value === null) {
    return null;
  }
  if (isLegacyStage(value)) {
    return LEGACY_STAGES[value];
  }
  return VALID_ONBOARDING_FLOW_STAGES.find(stage => stage === value) ?? null;
}
